<template>
  <q-fila v-if="aplica" :label="label" :completa="completa" :resaltar="resaltar">
    <div class="table-responsive">
      <table class="table table-sm table-bordered align-middle mb-0 q-matriz-composicion bg-white">
        <thead>
          <tr>
            <th style="width: 34%;">Cargo</th>
            <th style="width: 33%;">Condición</th>
            <th style="width: 33%;">Sexo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cargo in cargos" :key="cargo.campoCondicion">
            <td class="font-weight-bold">{{ cargo.etiqueta }}</td>
            <td>
              <select class="form-control form-control-sm"
                      :value="valorSelect(cargo.campoCondicion)"
                      :disabled="soloLectura"
                      @change="cambiar(cargo.campoCondicion, $event.target.value)">
                <option value="">Seleccione...</option>
                <option v-for="c in condiciones" :key="c.valor" :value="c.valor">{{ c.etiqueta }}</option>
              </select>
            </td>
            <td>
              <select class="form-control form-control-sm"
                      :value="valorSelect(cargo.campoSexo)"
                      :disabled="soloLectura"
                      @change="cambiar(cargo.campoSexo, $event.target.value)">
                <option value="">Seleccione...</option>
                <option v-for="s in sexos" :key="s.valor" :value="s.valor">{{ s.etiqueta }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/**
 * Matriz de composición de la mesa: una condición y un sexo por cargo.
 * Usa el mismo layout pregunta/respuesta que el resto de la ficha.
 */
export default {
  name: "QMatrizComposicion",
  components: { QFila },
  props: {
    valores: { type: Object, required: true },
    label: { type: String, default: "Composición de la mesa" },
    cargos: { type: Array, required: true },
    condiciones: { type: Array, required: true },
    sexos: { type: Array, required: true },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  computed: {
    completa() {
      return this.cargos.every((cargo) =>
        this.tieneTexto(this.valores[cargo.campoCondicion]) &&
        this.tieneTexto(this.valores[cargo.campoSexo])
      );
    },
  },
  methods: {
    tieneTexto(valor) {
      return valor !== null && valor !== undefined && String(valor).trim().length > 0;
    },
    valorSelect(campo) {
      const valor = this.valores[campo];
      return valor === null || valor === undefined ? "" : valor;
    },
    cambiar(campo, valor) {
      if (this.soloLectura) return;
      this.$emit("cambio", { campo: campo, valor: valor === "" ? null : valor });
    },
  },
};
</script>

<style scoped>
.q-matriz-composicion select.form-control {
  background-color: #fff;
}
</style>
